module.exports = __webpack_public_path__ + "static/media/sup_tropical.38507d55.jpg";